import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { Collapse } from 'react-collapse'

// Styles
import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';
import "./style.scss";

//Icons
import IconNotebook from "@learningblocks/protocol-constants/lib/Icons/notebook-solid";
import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";
import IconEdit from "@learningblocks/protocol-constants/lib/Icons/pencil-solid";

import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

export class ProtocolTask extends Component {
    constructor(props) {
        super(props);

        this.state = {
            createNoteView: false,
            readNoteView: false,
            normalView: true,
            menuOpen: false,
            note: ''
        }
    }

    handleClick = (e) => {
      const domNode = ReactDOM.findDOMNode(this.node)

      if(domNode){
        if(domNode.contains(e.target)){
          //Click is inside component
          return;
        }
        // Click is outside component -- close the menu
        this.setState({
            menuOpen: false
        })
      }
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.page !== prevProps.page){
        this.setState({
          createNoteView: false,
          readNoteView: false,
          normalView: true,
          menuOpen: false,
          note: ''
        })
      }

      if(prevProps.current !== this.props.current && this.props.current){
        this.task.parentNode.parentNode.scrollTop = this.task.offsetTop - 8;
      }
    }

    componentWillMount(){
      document.body.addEventListener('mousedown', this.handleClick, false);
    }

    componentWillUnmount(){
      document.body.removeEventListener('mousedown', this.handleClick, false);
    }

    showNotesClicked = () => {
        this.setState({
            readNoteView: !this.state.readNoteView,
            menuOpen: false,
            createNoteView: false
        })
    }

    createNoteClicked = () => {
        this.setState({
            createNoteView: !this.state.createNoteView,
            menuOpen: false,
            readNoteView: false,
        })

        if(this.props.notes[1] !== undefined){
          this.setState({ note: this.props.notes[1]})
        }

        if (
          this.props.pIndex === 5 &&
          this.props.tIndex === 0 &&
          (this.props.notes[1] === undefined)
        ) {

          let text =
            ("Lane 1 = "
            + "\n\nLane 2 = "
            + "\n\nLane 3 = "
            + "\n\nLane 4 = "
            + "\n\nLane 5 = "
            + "\n\nLane 6 = "
            )

          this.setState({
            note: text
          });
        }
    }

    toggleMenu = () => {
      this.setState({
          readNoteView: false,
          createNoteView: false,
          menuOpen: !this.state.menuOpen
      })
    }

    handleFormChange = (e) => {
      this.setState({
          note: e.target.value
      })
    }

    handleFormSubmit = (e) => {
      e.preventDefault();

      this.setState({
        menuOpen: false,
        createNoteView: false,
        note: ''
      });

      this.props.saveTaskNote({
        note: this.state.note,
        page: (this.props.page - 1),
        index: this.props.tIndex
      })
    }

  renderTaskModalBtn = () => {
    let btn = ''

    if(this.props.modal === undefined){
      return ""
    } else {

      //Choose type of button based on modal content
      if (this.props.modal.type === "PROTOCOL_TABLE"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "PROTOCOL_TABLE",
              size: "aside",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.modal.title}
        </button>)
      }
      if (this.props.modal.type === "DEPOSIT_SOLUTION"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "DEPOSIT_SOLUTION",
              size: "lg",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.modal.title}
        </button>)
      }

      if (this.props.modal.type === "PUT_ON_PPE"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "PUT_ON_PPE",
              size: "lg",
              connect: -1,
              data: {
                animation: "animations/Safty_Equipment.json"
              },
            });
          }}>
          {this.props.modal.title}
        </button>)
      }
      if (this.props.modal.type === "QUESTION_TABLE_FILL_IN") {
        // && this.props.current) {
        //Render countdown button
        btn = (
          <button
            className={"task-button"}
            onClick={(e) => {
              this.props.setModal({
                display: true,
                type: "QUESTION_TABLE_FILL_IN",
                size: "cover",
                connect: -1,
                data: this.props.modal,
              });
            }}
          >
            {this.props.modal.title}
          </button>
        );
      }

      if (this.props.modal.type === "PREPARE_GELBOX"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "PREPARE_GELBOX",
              size: "lg",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.modal.title}
        </button>)
      }
      if (this.props.modal.type === "LOAD_GELBOX_SOLUTION"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "LOAD_GELBOX_SOLUTION",
              size: "lg",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.modal.title}
        </button>)
      }
      if (this.props.modal.type === "RUN_GELBOX"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "RUN_GELBOX",
              size: "lg",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.modal.title}
        </button>)
      }
      if (this.props.modal.type === "VISUALISE_GEL"){// && this.props.current) {
        //Render countdown button
        btn = (<button
          className={'task-button'}
          onClick={e => {
            this.props.setModal({
              display: true,
              type: "VISUALISE_GEL",
              size: "lg",
              connect: -1,
              data: this.props.modal
            });
          }}>
          {this.props.modal.title}
        </button>)
      }

    }

    return btn
  }

  render() {
      return (
        <li
          className={"protocol-task" + ((this.props.current) ? " current-task" : "") + ((this.props.complete) ? " completed-task" : "")}
          tabIndex={0}
          ref={(task)=>{this.task = task}}
        >
          <div className="protocol-task-wrapper">
            <div className="index">
              <IconHexagon
                style={{ color: ((this.props.current) ? "white" : ((this.props.complete) ? colors.navy3 : colors.navy1)), height: '29px' }}
              />
              <span style={{ color: ((this.props.current) ? colors.navy1 : "white") }}>
                {(this.props.complete) ? " " : String.fromCharCode(97 + this.props.tIndex)}
              </span>
            </div>

            <span aria-label={this.props.aria} className="task-text"><ReactMarkdown rehypePlugins={[rehypeRaw]} components={{p: 'span'}}>{this.props.task.replace("\\_", "_")}</ReactMarkdown></span>
            <span> </span>
            <button className="anchor"
              onClick={this.showNotesClicked}
              style={{ display: (!this.state.readNoteView && this.props.notes.length > 0 ? "initial" : "none"), cursor: 'pointer' }}>
              <IconNotebook
                style={{ color: colors.charcoal1, height: '15px', top: '2px' }}
              />
            </button>
            <div className="protocol-menu"
              ref={node => this.node = node}>
              <button
                className="toggle-menu anchor"
                onClick={this.createNoteClicked}
                aria-label="Notes. Select to view the options."
              >
                <IconEdit
                  style={{ color: colors.navy1, height: '16px', top: '10px', right: '10px'}}
                />
              </button>
              {/* <Collapse
                isOpened={this.state.menuOpen}
                aria-hidden={!this.state.menuOpen}
                theme={{ collapse: 'collapse', content: 'collapse-content' }}
                style={{ position: 'absolute' }}
                springConfig={{ stiffness: 500, damping: 30 }}>

                <button
                  className="anchor"
                  onClick={this.createNoteClicked}
                  tabIndex={(this.state.menuOpen) ? null : -1}>
                  Add Note
                </button>
              </Collapse> */}
            </div>

            <Collapse
              isOpened={this.state.readNoteView}
              aria-hidden={!this.state.readNoteView}
              theme={{ collapse: 'collapse', content: 'collapse-content' }}
              springConfig={{ stiffness: 500, damping: 30 }}>
              <div className="notes-content">
                <div className="notes">
                  <p>Notes:</p>
                  <ul>
                    {this.props.notes.map((note, index) => (
                      <p key={index}>{note}</p>
                    ))}
                  </ul>
                </div>
                <button
                  className="anchor"
                  onClick={this.showNotesClicked}
                  tabIndex={(this.state.readNotesView) ? null : -1}>Hide</button>
              </div>
            </Collapse>
            <Collapse
              isOpened={this.state.createNoteView}
              aria-hidden={!this.state.createNoteView}
              style={{display: (!this.state.createNoteView)?"none": null}}>
              <form className="add-note-panel"
                onSubmit={(e) => { e.preventDefault() }}>
                <p>Observations:</p>
                <textarea
                  aria-label="Add observations text-entry field. Input text to add a note to this instruction."
                  placeholder="Add observations"
                  onChange={this.handleFormChange}
                  value={this.state.note}
                  tabIndex={(this.state.createNoteView) ? null : -1} />
                <div className="btns">
                  <button
                    aria-label="Cancel button. Select to discard changes you’ve made to your notes."
                    className="anchor"
                    onClick={this.createNoteClicked}
                    tabIndex={(this.state.createNoteView) ? null : -1}>Cancel</button>
                  <button
                    aria-label="Save note button. Select to save changes you’ve made to your notes."
                    type="submit"
                    tabIndex={(this.state.createNoteView) ? null : -1}
                    onClick={this.handleFormSubmit}>Save note</button>
                </div>
              </form>
            </Collapse>
          </div>
          {this.renderTaskModalBtn()}
        </li>
      );
  }
}

ProtocolTask.defaultProps = {
    notes: []
};
